import { Modal } from 'antd'
import { useRef, useState } from 'react'
import { SGeneralForms } from 'shj-components'
import { getArgPage } from '@/services/product'

export default function FormModal(props: any) {
  const { open, onConfirm, onCancel, paramList, type } = props
  const formRef = useRef<any>(null)
  const onFinish = () => {
    return new Promise((resolve, reject) => {
      formRef.current
        ?.onFormRef()
        ?.validateFields()
        .then(values => {
          onConfirm(values.productParam, paramList)
        })
        .catch(reject)
    })
  }
  const getOptions = async () => {
    let data: any = paramList
    if (type === 'unStandard') {
      data = data.filter(item => item.argType === 'CHOOSE')
    }
    return new Promise((resolve, reject) => {
      resolve({
        list: data,
      })
    })
  }
  return (
    <>
      <Modal
        title={type === 'standard' ? '添加参数' : '添加非规格参数'}
        open={open}
        onOk={onFinish}
        onCancel={onCancel}
        destroyOnClose
        maskClosable={false}
      >
        <SGeneralForms
          ref={formRef}
          httpOptionsFn={getOptions}
          layout={'vertical'}
          configs={[
            {
              formItem: [
                {
                  label: '产品参数',
                  name: 'productParam',
                  spanCol: 24,
                  required: true,
                  data: 'list',
                  type: 'select',
                  rules: [{ required: true, message: '请填写' }],
                  comConfig: {
                    mode: 'multiple',
                    fieldNames: { value: 'argCode', label: 'argName' },
                  },
                },
              ],
            },
          ]}
        />
      </Modal>
    </>
  )
}
